module.exports = __webpack_public_path__ + "static/media/dsc_1513.150d9194.jpg";